import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { clearStore } from "../../store/salesApiSlice";
import { useState } from "react";
import { mokiApi } from "../../services/loginApi";
function DropDownMenu(props) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const logout = () => {
    sessionStorage.removeItem("accessToken");
    sessionStorage.removeItem("name");
    try {
      const response = mokiApi.delete("/api/auth/logout");
    } catch (error) {
      console.error(error);
    }

    dispatch(clearStore());
    navigate("/");
  };
  const [lang, setLang] = useState("ko");

  const changeLang = (lang) => {
    setLang(lang);
    props.changeLanguage(lang);
  };

  return (
    <div className="p-5 w-[260px] max-h-[500px] overflow-y-scroll rounded-[25px] border border-[#e4e4e4] bg-white z-[1]">
      <div className="flex justify-between text-[4vw]">
        <div className="text-[#287398] " onClick={() => props.open()}>
          {props.t("close")}
        </div>
        <div
          className=" items-center justify-end text-left font-semibold text-[#d34570]"
          onClick={() => logout()}
        >
          {props.t("logout")}
        </div>
      </div>
      <div className="side-nav__bottom-name">
        {sessionStorage.getItem("name")}
      </div>
      <div style={{ marginTop: "10vw", fontWeight: "bold" }}>
        [{props.t("goto")}]
      </div>
      <div className="min-h-64 text-[4vw]">
        {props.sideList.map((element, index) => (
          <div
            key={index}
            className="side-nav__content"
            onClick={() => {
              props.open();
              props.onclickFunction(index);
            }}
            title={element}
          >
            <span className="ellipsis">
              {index + 1}. {element}
            </span>
          </div>
        ))}
      </div>
      <div className="side-nav__bottom">
        <div className="side-nav__bottom-language__div">
          <div
            className="side-nav__bottom-language"
            onClick={() => changeLang("ko")}
            style={{
              backgroundColor: lang === "ko" ? "#E96B76" : "transparent",
              color: lang === "ko" ? "white" : "black",
            }}
          >
            한국어
          </div>
          <div
            className="side-nav__bottom-language"
            onClick={() => changeLang("en")}
            style={{
              backgroundColor: lang === "en" ? "#E96B76" : "transparent",
              color: lang === "en" ? "white" : "black",
            }}
          >
            English
          </div>
        </div>
      </div>
    </div>
  );
}

export default DropDownMenu;
